<template>
    <div class="flex flex-col gap-6">
        <h3 class="text-lg  font-light uppercase text-center mt-6">Diagnostic delay is due to:</h3>

        <div class="flex flex-col md:flex-row gap-4">
            <div
                class="flex-1 border-solid rounded-xl border-t-20 border-lightblue bg-grey p-6 flex flex-col items-center gap-3"
            >
                <img src="@/assets/img/graphics/eskd/magnifying-glass.svg" alt="Magnifying glass icon" />

                <p class=" font-light text-center">
                    Low index of suspicion due to rarity, non-specific clinical presentation, and variability in age of
                    onset and severity<sup>1-3</sup>
                </p>
            </div>

            <div
                class="flex-1 border-solid rounded-xl border-t-20 border-purple bg-grey p-6 flex flex-col items-center gap-3"
            >
                <img src="@/assets/img/graphics/eskd/dna.svg" alt="DNA icon" />

                <p class=" font-light text-center">
                    Limited access to urinary metabolic and genetic screening<sup>1</sup>
                </p>
            </div>

            <div
                class="flex-1 border-solid rounded-xl border-t-20 border-maroon bg-grey p-6 flex flex-col items-center gap-3"
            >
                <img src="@/assets/img/graphics/eskd/hourglass-split.svg" alt="Hourglass icon" />

                <p class=" font-light text-center">
                    Less overt symptoms in adults reducing urgency to diagnose<sup>4</sup>
                </p>
            </div>
        </div>

        <p class=" font-light text-center">
            Earlier diagnosis of PH1 may delay the systemic build up of oxalate in multiple systems (eyes, heart, bone,
            and skin) and thus delay progression to systemic oxalosis and ESKD<sup>2,5,6</sup>
        </p>

        <div class="p-4 bg-lightblue50 font-semibold my-6 text-center">
            Diagnostic delay, and its potential consequences, may be avoided by being aware of the signs and symptoms of
            PH1 and facilitating testing of appropriate patients<sup>4,5</sup>
        </div>
    </div>
</template>
